import { RouteType } from "types/RouteType";
// Legacy in-app AI Agent retired in favor of @intrasync/ai-agent's AgentHub
// (mounted at /ai-agent via src/views/aiAgent/aiAgentRoutesList.ts).
import dashboardRoute from "./Dashboard/dashboard.Route";
import departmentsRoute from "./Departments/departments.Route";
import permissionsRoute from "./Permissions/permissions.Route";
import standardProceduresRoute from "./StandardProcedures/standardProcedures.Route";
import userManagementRoute from "./UserManagement/userManagement.Route";

const administrationRoutesList: RouteType[] = [
    ...dashboardRoute,
    departmentsRoute,
    ...permissionsRoute,
    standardProceduresRoute,
    ...userManagementRoute,
];

export default administrationRoutesList;
